export const SET_GENERAL_SETTINGS = 'SET_GENERAL_SETTINGS'